import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaWallet, FaUserCircle, FaCog, FaCheck, FaSignOutAlt, FaRupeeSign } from "react-icons/fa";

const ReporterHeader = ({ isProfileComplete, onLogout }) => {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/get/wallet/detail`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        setBalance(response.data.balance || 0);
      } catch (err) {
        console.error("Failed to fetch balance:", err);
      }
    };
    fetchBalance();
  }, []);

  return (
    <header className="reporter-header bg-white/80 backdrop-blur-md sticky top-0 z-30 h-16 border-b border-slate-100 flex items-center justify-between px-4 sm:px-8">
      <div className="flex items-center gap-4">
        {/* Profile Completion Indicator (Desktop) */}
        <div className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-50 border border-slate-100">
          <div className={`w-2 h-2 rounded-full ${isProfileComplete ? 'bg-green-500' : 'bg-amber-500 animate-pulse'}`} />
          <span className="text-[10px] font-black uppercase tracking-tight text-slate-600">
            {isProfileComplete ? 'Identity Verified' : 'Complete Profile'}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        {/* Wallet Balance */}
        <button
          onClick={() => navigate('/reporter/wallet')}
          className="group flex items-center gap-2 px-3 py-1.5 rounded-xl bg-indigo-50 hover:bg-indigo-100 border border-indigo-100 transition-all active:scale-95 shadow-sm"
          title="Available Balance"
        >
          <div className="p-1 rounded-lg bg-indigo-600 shadow-sm text-white group-hover:scale-110 transition-transform">
            <FaWallet className="w-3 h-3" />
          </div>
          <div className="flex flex-col items-start leading-none gap-0.5">
            <span className="text-[7px] font-black text-indigo-400 uppercase tracking-widest">Available</span>
            <span className="text-xs font-black text-indigo-700 flex items-center">
              <FaRupeeSign className="w-2 h-2 mr-0.5" />
              {balance !== null ? balance.toLocaleString('en-IN', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '...'}
            </span>
          </div>
        </button>

        <div className="h-6 w-px bg-slate-100 mx-1 hidden sm:block" />

        <div className="flex items-center gap-1.5">
          {/* Profile Toggle */}
          <button
            onClick={() => navigate('/reporter/account')}
            className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-slate-50 rounded-xl transition-all relative group"
            title="Account Management"
          >
            <FaUserCircle className="w-5 h-5 group-hover:scale-110 transition-transform" />
            {isProfileComplete && (
              <div className="absolute top-1 right-1 bg-green-500 rounded-full p-0.5 ring-2 ring-white">
                <FaCheck className="w-1.5 h-1.5 text-white" />
              </div>
            )}
          </button>

          {/* Settings */}
          <button
            onClick={() => navigate('/reporter/settings')}
            className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-slate-50 rounded-xl transition-all group"
            title="Security Settings"
          >
            <FaCog className="w-5 h-5 group-hover:rotate-45 transition-transform" />
          </button>

          {/* Logout (Mobile Only) */}
          <button
            onClick={onLogout}
            className="lg:hidden p-2 text-rose-500 hover:bg-rose-50 rounded-xl transition-all active:scale-90"
            title="Log out"
          >
            <FaSignOutAlt className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default ReporterHeader;
